/* tslint:disable */
/* eslint-disable */
/**
 * Areeb Admin API
 * Areeb Admin REST API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SupplierBatchLineDto } from './SupplierBatchLineDto';
import {
    SupplierBatchLineDtoFromJSON,
    SupplierBatchLineDtoFromJSONTyped,
    SupplierBatchLineDtoToJSON,
} from './SupplierBatchLineDto';

/**
 * 
 * @export
 * @interface SupplierBatchDto
 */
export interface SupplierBatchDto {
    /**
     * 
     * @type {number}
     * @memberof SupplierBatchDto
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof SupplierBatchDto
     */
    supplierId: number;
    /**
     * 
     * @type {string}
     * @memberof SupplierBatchDto
     */
    supplierName: string | null;
    /**
     * 
     * @type {string}
     * @memberof SupplierBatchDto
     */
    supplierPhone: string | null;
    /**
     * 
     * @type {string}
     * @memberof SupplierBatchDto
     */
    status: SupplierBatchDtoStatusEnum;
    /**
     * 
     * @type {Date}
     * @memberof SupplierBatchDto
     */
    periodStart: Date;
    /**
     * 
     * @type {Date}
     * @memberof SupplierBatchDto
     */
    periodEnd: Date;
    /**
     * 
     * @type {string}
     * @memberof SupplierBatchDto
     */
    notes: string | null;
    /**
     * 
     * @type {Date}
     * @memberof SupplierBatchDto
     */
    sentAt: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof SupplierBatchDto
     */
    respondedAt: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof SupplierBatchDto
     */
    completedAt: Date | null;
    /**
     * 
     * @type {string}
     * @memberof SupplierBatchDto
     */
    createdBy: string;
    /**
     * Email of the admin user who created this batch (resolved from createdBy id)
     * @type {string}
     * @memberof SupplierBatchDto
     */
    createdByEmail: string | null;
    /**
     * 
     * @type {Date}
     * @memberof SupplierBatchDto
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof SupplierBatchDto
     */
    updatedAt: Date;
    /**
     * 
     * @type {Array<SupplierBatchLineDto>}
     * @memberof SupplierBatchDto
     */
    lines: Array<SupplierBatchLineDto>;
    /**
     * Distinct orders touched by this batch
     * @type {number}
     * @memberof SupplierBatchDto
     */
    orderCount: number;
    /**
     * Number of product lines in this batch
     * @type {number}
     * @memberof SupplierBatchDto
     */
    lineCount: number;
}


/**
 * @export
 */
export const SupplierBatchDtoStatusEnum = {
    PendingReview: 'PENDING_REVIEW',
    SentToSupplier: 'SENT_TO_SUPPLIER',
    SupplierResponded: 'SUPPLIER_RESPONDED',
    ChangesPropagated: 'CHANGES_PROPAGATED',
    Completed: 'COMPLETED'
} as const;
export type SupplierBatchDtoStatusEnum = typeof SupplierBatchDtoStatusEnum[keyof typeof SupplierBatchDtoStatusEnum];


/**
 * Check if a given object implements the SupplierBatchDto interface.
 */
export function instanceOfSupplierBatchDto(value: object): value is SupplierBatchDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('supplierId' in value) || value['supplierId'] === undefined) return false;
    if (!('supplierName' in value) || value['supplierName'] === undefined) return false;
    if (!('supplierPhone' in value) || value['supplierPhone'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('periodStart' in value) || value['periodStart'] === undefined) return false;
    if (!('periodEnd' in value) || value['periodEnd'] === undefined) return false;
    if (!('notes' in value) || value['notes'] === undefined) return false;
    if (!('sentAt' in value) || value['sentAt'] === undefined) return false;
    if (!('respondedAt' in value) || value['respondedAt'] === undefined) return false;
    if (!('completedAt' in value) || value['completedAt'] === undefined) return false;
    if (!('createdBy' in value) || value['createdBy'] === undefined) return false;
    if (!('createdByEmail' in value) || value['createdByEmail'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('lines' in value) || value['lines'] === undefined) return false;
    if (!('orderCount' in value) || value['orderCount'] === undefined) return false;
    if (!('lineCount' in value) || value['lineCount'] === undefined) return false;
    return true;
}

export function SupplierBatchDtoFromJSON(json: any): SupplierBatchDto {
    return SupplierBatchDtoFromJSONTyped(json, false);
}

export function SupplierBatchDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SupplierBatchDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'supplierId': json['supplierId'],
        'supplierName': json['supplierName'],
        'supplierPhone': json['supplierPhone'],
        'status': json['status'],
        'periodStart': (new Date(json['periodStart'])),
        'periodEnd': (new Date(json['periodEnd'])),
        'notes': json['notes'],
        'sentAt': (json['sentAt'] == null ? null : new Date(json['sentAt'])),
        'respondedAt': (json['respondedAt'] == null ? null : new Date(json['respondedAt'])),
        'completedAt': (json['completedAt'] == null ? null : new Date(json['completedAt'])),
        'createdBy': json['createdBy'],
        'createdByEmail': json['createdByEmail'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
        'lines': ((json['lines'] as Array<any>).map(SupplierBatchLineDtoFromJSON)),
        'orderCount': json['orderCount'],
        'lineCount': json['lineCount'],
    };
}

export function SupplierBatchDtoToJSON(value?: SupplierBatchDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'supplierId': value['supplierId'],
        'supplierName': value['supplierName'],
        'supplierPhone': value['supplierPhone'],
        'status': value['status'],
        'periodStart': ((value['periodStart']).toISOString()),
        'periodEnd': ((value['periodEnd']).toISOString()),
        'notes': value['notes'],
        'sentAt': (value['sentAt'] == null ? null : (value['sentAt'] as any).toISOString()),
        'respondedAt': (value['respondedAt'] == null ? null : (value['respondedAt'] as any).toISOString()),
        'completedAt': (value['completedAt'] == null ? null : (value['completedAt'] as any).toISOString()),
        'createdBy': value['createdBy'],
        'createdByEmail': value['createdByEmail'],
        'createdAt': ((value['createdAt']).toISOString()),
        'updatedAt': ((value['updatedAt']).toISOString()),
        'lines': ((value['lines'] as Array<any>).map(SupplierBatchLineDtoToJSON)),
        'orderCount': value['orderCount'],
        'lineCount': value['lineCount'],
    };
}

